import api from '@/js/services/axios'
import urlUtil from '@/js/utils/urlUtil'

const CDN_URL = process.env.VUE_APP_CDN_URL

export default {
  LAYOUT_STYLE_CARD: "CARD",
  LAYOUT_STYLE_WEEK: "WEEK",
  // Organization type constants
  ORGANIZATION_TYPE_INDIVIDUAL: 'individual',
  ORGANIZATION_TYPE_STUDIO: 'organization',


  findByIdentifier (identifier) {
    var queryMap = new Map()
    queryMap.set('identifier', identifier)
    var query = urlUtil.prepareQuery(queryMap)

    return new Promise((resolve, reject) => {
      api.get('public/v1/org/find' + query)
        .then(response => {
          var data = response.data
          resolve(this._processOrganization(data))
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  findShowcase() {
    return new Promise((resolve, reject) => {
      api.get('public/v1/org/showcase')
        .then(response => {
          const organizations = response.data.map(org => this._processOrganization(org));
          resolve(organizations);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  _processOrganization(organization){
    if (!organization){
      return null
    }

    if (organization.frontend_settings && typeof organization.frontend_settings === 'string'){
      try {
        let frontendSettings = JSON.parse(organization.frontend_settings);
        organization.frontend_settings = frontendSettings;
        
      } catch (error) {
        throw new Error('Failed to parse frontend settings JSON:', error);
      }
    }

    if (organization.social_media_settings && typeof organization.social_media_settings === 'string'){
      try {
        let socialMediaSettings = JSON.parse(organization.social_media_settings);
        organization.social_media_settings = socialMediaSettings;
        
      } catch (error) {
        throw new Error('Failed to parse social media settings JSON:', error);
      }
    }

    if (organization.mypages_settings && typeof organization.mypages_settings === 'string'){
      try {
        let mypagesSettings = JSON.parse(organization.mypages_settings);
        organization.mypages_settings = mypagesSettings;
        
      } catch (error) {
        console.warn('Failed to parse mypages_settings JSON:', error);
        // Don't throw error for mypages_settings as it might be optional
        organization.mypages_settings = null;
      }
    }

    if (organization.organization_settings && typeof organization.organization_settings === 'string'){
      try {
        let organizationSettings = JSON.parse(organization.organization_settings);
        organization.organization_settings = organizationSettings;
        
      } catch (error) {
        console.warn('Failed to parse organization_settings JSON:', error);
        // Don't throw error for organization_settings as it might be optional
        organization.organization_settings = null;
      }
    }

    if (organization.membership_settings && typeof organization.membership_settings === 'string'){
      try {
        organization.membership_settings = JSON.parse(organization.membership_settings);
      } catch (error) {
        console.warn('Failed to parse membership_settings JSON:', error);
        organization.membership_settings = null;
      }
    }

    let identifier = organization.identifier
    if (identifier){
      let coverImageSrc = CDN_URL + '/organization/' + identifier + '/' + identifier
      
      if (!coverImageSrc.endsWith('.jpg') && !coverImageSrc.endsWith('.webp')){
        coverImageSrc = ""
      }


      organization.src_image_1920_webp = coverImageSrc
      organization.src_image_600_webp = organization.src_image_1920_webp.replace('_1920.', '_600.')
      organization.src_image_1200_webp = organization.src_image_1920_webp.replace('_1920.', '_1200.')
      organization.src_image_600_jpg = organization.src_image_600_webp.replace('.webp', '.jpg')
      organization.src_image_1200_jpg = organization.src_image_1200_webp.replace('.webp', '.jpg')
      organization.src_image_1920_jpg = organization.src_image_1920_webp.replace('.webp', '.jpg')
    }

    if (organization.logo_url) {
      if (CDN_URL && organization.logo_url.startsWith('organization/')) {
        organization.logo_url = CDN_URL + '/' + organization.logo_url
        organization.src_logo_small = organization.logo_url.replace('.jpg', '_40.jpg')
        organization.src_logo_large = organization.logo_url.replace('.jpg', '_144.jpg')
      } else {
        organization.src_logo_large = organization.logo_url
        organization.src_logo_small = organization.logo_url
      }
    }

    return organization
  }
}
